import React from "react";
import NavTop from "./NavTop/navTop";
import Header from "./Header/Header";
import About from "./About/About";
import Video from "./Video/Video";
import Ventajas from "./Ventajas/Ventajas";
import MyTeam from "./MyTeam/MyTeam";
import Testimonios from "./Testimonios/Testimonios";
import ContactUs from "./ContactUs/ContactUs";
import Footer from "./Footer/Footer";
import Questions from "./Questions/Questions";

export default function Body() {
  return (
    <>
      <NavTop />
      <Header />
      <About />
      <Video />
      <Ventajas />
      <Questions />
      <MyTeam />
      <Testimonios />
      <ContactUs />
      <Footer />
    </>
  );
}
